import { connect } from 'react-redux';
import LocationsContainer from './locations-container';
import {addLocationT, setLocationsT} from "../../../../state/actions/shared/location";

const mapStateToProps = (state, ownProps) => {
  const {entityId} = ownProps;

  return {
    locations: state.companyCategories.editor[entityId]?.locations,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {entityId:id} = ownProps;
  return {
    addLocation: (location) => dispatch(addLocationT('company_category', location, id)),
    setLocations: (locations) => dispatch(setLocationsT('company_category', locations, id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationsContainer);
